import * as React from "react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import { getDate } from "../../utils/data";
import Comments from "./comments";
import { IconWithToolTip } from "../common";
import { appLogger } from "../../utils";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import PreviewAttachmentModalLarge from "./previewAttachmentModalLarge";
import { useState } from "react";
function PaperComponent(props: any) {
  appLogger.info({
    infoObj: {
      method: "PaperComponent",
      component: "feedback",
      fileName: "previewAttachmantModal.tsx",
      props: props,
    },
  });
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

interface IProps {
  attachmentUrl: string;
  datas?: any;
  openAttachmentPrvModal: boolean;
  closeAttachmentPrvModal: any;
  attachmentType?: string;
}

export default function previewAttachmentModal(props: IProps) {
  const {
    openAttachmentPrvModal,
    closeAttachmentPrvModal,
    attachmentUrl,
    datas,
    attachmentType,
  } = props;
  const [openAttachmentLargePrvModal, setopenAttachmentLargePrvModal] =
    useState<any>(false);

  const zoomClick = () => {
    setopenAttachmentLargePrvModal(true);
  };
  const closeAttachmentLargePrvModalFn = () => {
    setopenAttachmentLargePrvModal(false);
  };

  return (
    <div>
      <Dialog
        open={openAttachmentPrvModal}
        onClose={closeAttachmentPrvModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="lg"
        fullWidth
      >
        {attachmentType != "" && (
          <DialogTitle
            className="close-preview enlarge"
            style={{ cursor: "move" }}
            id="draggable-dialog-title"
          >
            <span
              className="largepopupTtile"
              style={{ textTransform: "capitalize" }}
            >
              {attachmentType + " " + "Preview"}
            </span>
            <IconButton
              onClick={closeAttachmentPrvModal}
              style={{ fontSize: "1rem" }}
            >
              <IconWithToolTip message="Close" iconName="icon-close" />
            </IconButton>
          </DialogTitle>
        )}
        <DialogContent>
          <DialogContentText>
            <Box sx={{ width: "100%" }}>
              <Grid container>
                <Grid
                  item
                  xs={8}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {attachmentType != "" && (
                    <Box sx={{ p: 1 }}>
                      {attachmentType === "video" ? (
                        <div style={{ textAlign: "center" }}>
                          <video controls autoPlay>
                            <source src={attachmentUrl} type="video/mp4" />
                          </video>
                          <div
                            className="feedbackAttachLargePreviewZoomicon"
                            style={{ margin: "20px auto 0px" }}
                            onClick={() => zoomClick()}
                          >
                            {" "}
                            {openAttachmentLargePrvModal ? (
                              // <ZoomOutIcon />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <ZoomInIcon />
                                </div>
                                <div> Click to see enlarge video</div>
                              </div>
                            ) : (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {" "}
                                  <div>
                                    <ZoomInIcon />
                                  </div>
                                  <div> Click to see enlarge video</div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      ) : attachmentType === "audio" ? (
                        <div>
                          <audio src={attachmentUrl} controls preload="auto" />
                        </div>
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <img src={attachmentUrl}></img>
                          <div
                            className="feedbackAttachLargePreviewZoomicon"
                            onClick={() => zoomClick()}
                            style={{ margin: "30px auto 0px" }}
                          >
                            {openAttachmentLargePrvModal ? (
                              // <ZoomOutIcon />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <ZoomInIcon />
                                </div>
                                <div> Click to see enlarge image</div>
                              </div>
                            ) : (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <ZoomInIcon />
                                  </div>
                                  <div> Click to see enlarge image</div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </Box>
                  )}
                </Grid>
                {datas && !datas.createdOn && (
                  <Grid xs={4}>
                    <List>
                      <ListItem className="img-data-li">
                        {/* <ListItemAvatar>
                          <Avatar
                            alt="Remy Sharp"
                            src="/static/images/avatar/1.jpg"
                          />
                        </ListItemAvatar> */}
                        <ListItemText
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className="img-prv-lable"
                              >
                                User Name:{" "}
                              </Typography>
                              <Typography component="span" variant="body2">
                                {datas && datas.userId ? datas.userId : " - "}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <ListItem className="img-data-li">
                        <ListItemText
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className="img-prv-lable"
                              >
                                Source Ip:{" "}
                              </Typography>
                              <Typography component="span" variant="body2">
                                {datas && datas.sourceIP
                                  ? datas.sourceIP
                                  : " - "}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <ListItem className="img-data-li">
                        <ListItemText
                          // primary="Date:"
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className="img-prv-lable"
                              >
                                Date:{" "}
                              </Typography>
                              <Typography component="span" variant="body2">
                                {datas && datas.createdOn
                                  ? getDate(datas && datas.createdOn)
                                  : ""}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <ListItem className="img-data-li">
                        <ListItemText
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className="img-prv-lable"
                              >
                                Product Version:{" "}
                              </Typography>
                              <Typography component="span" variant="body2">
                                {datas && datas.productVersion
                                  ? datas.productVersion
                                  : " - "}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <ListItem className="img-data-li">
                        <ListItemText
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className="img-prv-lable"
                              >
                                Category:{" "}
                              </Typography>
                              <Typography component="span" variant="body2">
                                {datas && datas.feedbackCategory
                                  ? datas.feedbackCategory
                                  : " - "}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <ListItem className="img-data-li">
                        <ListItemText
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className="img-prv-lable"
                              >
                                Comments :{" "}
                              </Typography>
                              <Typography component="span" variant="body2">
                                {datas && datas.feedbackComments ? (
                                  <Comments
                                    className="img-prv-lable"
                                    comments={
                                      datas &&
                                      datas.feedbackComments &&
                                      typeof datas.feedbackComments === "string"
                                        ? JSON.parse(datas.feedbackComments)
                                        : undefined
                                    }
                                    category={datas && datas.feedbackCategory}
                                    feedbackType={datas && datas.feedbackType}
                                  />
                                ) : (
                                  ""
                                )}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    </List>
                  </Grid>
                )}
              </Grid>
            </Box>
            {/* <img src={attachmentUrl}></img> */}
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <PreviewAttachmentModalLarge
        attachmentUrl={attachmentUrl}
        datas={datas}
        attachmentType={attachmentType}
        openAttachmentLargePrvModal={openAttachmentLargePrvModal}
        closeAttachmentLargePrvModalFn={closeAttachmentLargePrvModalFn} // closeAttachmentLargePrvModal={closeAttachmentLargePrvModalFn}
      />
    </div>
  );
}
